import { ReactNode } from 'react';

import { DataTableClassNames } from '../../constants';

import {
  RowActionCellChildren,
  RowActionCellRoot,
} from './RowActionCell.styled';

type Props = {
  children: ReactNode;
};

const RowActionCell = ({ children }: Props) => (
  <RowActionCellRoot
    className={DataTableClassNames.Action}
    data-column="_action">
    <RowActionCellChildren className={DataTableClassNames.ActionChildren}>
      {children}
    </RowActionCellChildren>
  </RowActionCellRoot>
);

export default RowActionCell;
